var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inviteRedirectView"},[_c('app-message',{attrs:{"type":"error","messages":_vm.errorMessages},on:{"close":function($event){_vm.errorMessages=[]}}}),_vm._v(" "),_c('loading-spinner',{attrs:{"custom-class":"overlay","show-spinner":_vm.isInitializingView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }